type MobileNavigator = Pick<Navigator, 'maxTouchPoints' | 'platform' | 'userAgent'> & {
  userAgentData?: { mobile?: boolean };
};

export const isMobilePwaDevice = (currentNavigator: MobileNavigator): boolean => {
  if (currentNavigator.userAgentData?.mobile === true) return true;
  if (/android|iphone|ipad|ipod|mobile/i.test(currentNavigator.userAgent)) return true;
  return currentNavigator.platform === 'MacIntel' && currentNavigator.maxTouchPoints > 1;
};

export const isIosPwaDevice = (currentNavigator: MobileNavigator): boolean => (
  /iphone|ipad|ipod/i.test(currentNavigator.userAgent)
  || (currentNavigator.platform === 'MacIntel' && currentNavigator.maxTouchPoints > 1)
);
